import { Divider, Grid, TextField, useMediaQuery } from "@material-ui/core";
import React from "react";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

const NotificationPreview = ({ customNotification, setCustomNotification }) => {
  const TITLE_CHARACTER_LIMIT = 40;
  const BODY_CHARACTER_LIMIT = 144;
  const isDesktop = useMediaQuery("(min-width: 600px)");

  return (
    <Grid container spacing={2} justify="center">
      <Grid item xs={12} sm={4}>
        <h3 className="mb-2">Live Preview</h3>
        <div
          className="blured-xs-box px-3 py-2"
          style={{ minWidth: 150, maxHeight: 250 }}
        >
          <div className="d-flex justify-content-between">
            <div className="d-flex align-items-end mb-2">
              <img
                src={toAbsoluteUrl("/media/logos/logo_contained.png")}
                alt="logo"
                width="18px"
                className="mr-3 rounded"
              />
              THE ZONE
            </div>
            <p>Now</p>
          </div>
          <div>
            <h3 className="text-break">
              {customNotification.title === 0
                ? "Title has a 40-character limit"
                : customNotification.title}
            </h3>
            <h6 className="font-weight-light">
              {customNotification.body.length === 0
                ? 'Body has a 144-character limit. PLEASE use the "ANNOUNCEMENTS" feature for sharing Rich Long Text, Links, Videos, and Docs'
                : customNotification.body}
            </h6>
          </div>
        </div>
      </Grid>
      <Divider
        orientation={isDesktop ? "vertical" : "horizontal"}
        flexItem={isDesktop}
        className={!isDesktop ? "w-100" : ""}
      />
      <Grid container item xs={12} sm={8} spacing={2}>
        <Grid item xs={12}>
          <h3 className="mb-4">Type Here</h3>
          <TextField
            inputProps={{
              maxLength: TITLE_CHARACTER_LIMIT,
            }}
            value={customNotification.title}
            fullWidth
            required
            id="title_notifications_btn"
            variant="outlined"
            label={`Title | ${customNotification.title.length}/${TITLE_CHARACTER_LIMIT}`}
            name="title"
            onChange={(e) =>
              setCustomNotification({
                ...customNotification,
                title: e.target.value,
              })
            }
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            inputProps={{
              maxLength: BODY_CHARACTER_LIMIT,
            }}
            value={customNotification.body}
            multiline
            required
            fullWidth
            rows={4}
            id="body_notifications_btn"
            variant="outlined"
            label={`Body | ${customNotification.body.length}/${BODY_CHARACTER_LIMIT}`}
            name="body"
            onChange={(e) =>
              setCustomNotification({
                ...customNotification,
                body: e.target.value,
              })
            }
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default NotificationPreview;
